<template>
   <footer class="site-footer">
        <div class="inner">
            <div class="brand">
                <span class="brand-name">{{ t('pages.main.footer.brandName') }}</span>
                <span>{{ t('pages.main.footer.copyright') }}</span>
            </div>
            <div class="links">
                <a href="https://bilbomusic.com" target="_blank" rel="noopener noreferrer">
                    {{ t('pages.main.footer.externalLink') }}
                </a>
                <!-- <a href="#" @click.prevent="openAuthModal">
                    {{ t('pages.main.footer.pairDevice') }}
                </a>
                <a href="#">{{ t('pages.main.footer.terms') }}</a> -->
            </div>
        </div>
    </footer>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables.scss' as *;
.site-footer {
    margin-top: auto;
    border-top: 1px solid $color-border-subtle;
    padding: 2.5rem 0;

    .inner {
        max-width: 72rem;
        margin: 0 auto;
        padding: 0 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        font-size: 0.75rem;
        color: $color-subtle;
        font-weight: 500;

        @include bapps.respond-to("sm") {
            flex-direction: row;
            padding: 0 2rem;
        }
        @include bapps.respond-to("lg") {
            padding: 0 3rem;
        }
    }

    .brand {
        @include bapps.flex-align-center;
        gap: 0.5rem;

        .brand-name {
            font-family: $font-display;
            font-weight: 700;
            color: $color-charcoal;
        }
    }

    .links {
        @include bapps.flex-align-center;
        gap: 1.5rem;

        a {
            @include bapps.transition-smooth(color);

            &:hover {
                color: $color-charcoal;
            }
        }
    }
}
</style>
